export function getGraphqlErrorCode(error: unknown): string | undefined {
  return (
    (error as { graphQLErrors?: Array<{ extensions?: { code?: string } }> })?.graphQLErrors?.[0]?.extensions
      ?.code ?? (error as { extensions?: { code?: string } })?.extensions?.code
  );
}
